import _lib from '../_lib';
import { AdminRegisterNavigation } from '@/store/modules/fsm/messages';
import { clearReport } from '@/mutation-types';
import active from './active/index';
import { getAdministrator } from "@/data/getters";
import Vue from 'vue';

function theTest(instance, message) {
  return (message.message == AdminRegisterNavigation &&
    instance.context.rootState.login.phrData &&
    getAdministrator(instance.context.rootState.login.phrData));
}
export default ({ tree, parent, api }) => {
  let regionName = 'adminregister';
  let activations = [
    {
      name: 'adminregister',
      test: theTest
    }
  ];
  let activeIndex = active;
  let func = _lib({ regionName, activations, activeIndex });
  return func({ tree, parent, api });
};
